import React from 'react';

const IntelligenceIcon = () => {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M22 15.4792C22 13.3173 21.272 11.7652 19.829 10.8322C19.649 3.98025 16.831 0.78125 11 0.78125C5.169 0.78125 2.35 3.98025 2.171 10.8322C0.728 11.7652 0 13.3173 0 15.4792C0 19.2582 2.223 21.1752 6.606 21.1752C7.251 21.1752 7.824 20.7633 8.028 20.1523C9.037 17.1383 9.037 13.8202 8.028 10.8062C7.823 10.1952 7.251 9.78325 6.606 9.78325C6.118 9.78325 5.657 9.80725 5.222 9.85425C5.653 4.28325 8.297 3.78125 11 3.78125C13.703 3.78125 16.347 4.28325 16.778 9.85425C16.344 9.80725 15.882 9.78325 15.394 9.78325C14.749 9.78325 14.176 10.1952 13.972 10.8062C13.175 13.1862 13.008 15.7582 13.471 18.2202C12.719 18.2172 11.994 18.1882 11.302 18.1332C10.473 18.0722 9.753 18.6833 9.688 19.5093C9.622 20.3353 10.238 21.0582 11.064 21.1232C11.876 21.1872 12.727 21.2213 13.607 21.2213C14.202 21.2213 14.81 21.2063 15.429 21.1763C19.79 21.1663 22.001 19.2502 22.001 15.4802L22 15.4792Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default IntelligenceIcon;
